var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Benefits")]),(_vm.futureCurrentDurationDiff)?_c('p',[_c('i',{staticClass:"icon-icon-clock-blue"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.futureCurrentDurationDiff)}})]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f035b2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TripPlannerFutureBenefits.vue
// module id = null
// module chunks = 